/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { upperFirst } from 'lodash'
import { useIntl } from 'react-intl'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'

function TrusteeField (props: FormTextFieldProps) {
  const { name = 'trustee', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'trustee',
        defaultMessage: 'Syndic'
      })}
      name={name}
      parser={upperFirst}
      {...others}
    />
  )
}

export default TrusteeField
